import React from 'react';
import { useSelector } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import type { SportId } from 'app/lib/betting/constants';
import { Breadcrumb } from 'app/modules/Betting';
import { gridSubheaderBreadcrumbSelector } from 'app/modules/Prematch/selectors/gridPresentation';

type SubheaderBreadcrumbsProps = {
  matchIds: Array<number>;
  sportId: SportId;
};

export const SubheaderBreadcrumbs = ({ matchIds, sportId }: SubheaderBreadcrumbsProps) => {
  const breadcrumbs = useSelector(
    (state: ReduxState) => gridSubheaderBreadcrumbSelector(state, [...matchIds][0]));

  return (
    <Breadcrumb breadcrumbs={breadcrumbs}
                sportId={sportId} />
  );
};
